import {
  IAppointmentScopeData,
  IAppointmentTemplateContext,
} from './appointment-context';
import { ICandidateCalendarEvent } from '../../event/calendar-event';
import { IPatientTemplateContext } from './patient-context';
import { IPracticeTemplateContext } from './practice-context';
import { ITemplateContext } from '../templating';
import { WithRef } from '@principle-theorem/shared';

export interface IGapScopeData extends IAppointmentScopeData {
  gapCandidate: WithRef<ICandidateCalendarEvent>;
  gapOfferConfirmUrl: string;
}

export interface IGapTemplateContext
  extends ITemplateContext,
    IAppointmentTemplateContext,
    IPatientTemplateContext,
    IPracticeTemplateContext {
  gapOfferConfirmUrl: string;
  gapOfferStartDate: string;
}
